module.exports = __webpack_public_path__ + "media/images/type-5-9a5f75029dc91d5b5449bbf38461ac6d.png";